import innerHeight from "ios-inner-height";
import logger from "logging/logger";
import Bowser from "bowser";
import { webViewInfo } from "../utils/webView";

/**
 * @deprecated use state in modules/systemCheck/redux/ for everything except for
 * updateCheckTime, getLastCheckTime, hasBarInIOS, and webViewInfo.
 */
const browserInfo = () => {
  const getLastCheckTime = () => {
    const compatibilityCheckTime = localStorage.getItem(
      "compatibility_check_time",
    );

    return compatibilityCheckTime ? parseInt(compatibilityCheckTime, 10) : null;
  };

  const updateCheckTime = () => {
    try {
      localStorage.setItem(
        "compatibility_check_time",
        new Date().getTime().toString(),
      );
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "";
      logger.warn(`updateCheckTime: ${errorMessage}`);
    }
  };
  const hasBarInIOS = innerHeight() !== window.innerHeight;

  const browser = Bowser.getParser(window.navigator.userAgent);

  return {
    hasBarInIOS,
    updateCheckTime,
    getLastCheckTime,
    deviceName: browser.getPlatform().model,
    osName: browser.getOS().name,
    osVersion: browser.getOS().version,
    browserName: browser.getBrowser().name,
    browserVersion: browser.getBrowser().version,
    browser,
    webViewInfo: webViewInfo(browser),
  };
};

export default browserInfo;
